var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.59175 9.76155C5.66986 9.68408 5.73185 9.59192 5.77416 9.49037C5.81646 9.38883 5.83825 9.27991 5.83825 9.1699C5.83825 9.05989 5.81646 8.95097 5.77416 8.84942C5.73185 8.74788 5.66986 8.65571 5.59175 8.57824L2.84181 5.83663L9.16668 5.83663C9.38769 5.83663 9.59965 5.74883 9.75593 5.59256C9.9122 5.43628 10 5.22432 10 5.00331C10 4.7823 9.9122 4.57035 9.75593 4.41407C9.59965 4.25779 9.38769 4.17 9.16668 4.17L2.84181 4.17L5.59175 1.42838C5.74867 1.27147 5.83682 1.05864 5.83682 0.836727C5.83682 0.614813 5.74867 0.401988 5.59175 0.245072C5.43484 0.0881549 5.22201 0 5.0001 0C4.77818 0 4.56536 0.0881549 4.40844 0.245072L0.241857 4.41166C0.165991 4.49091 0.106521 4.58436 0.0668592 4.68665C0.0227728 4.7864 0 4.89426 0 5.00331C0 5.11237 0.0227728 5.22022 0.0668592 5.31997C0.106521 5.42226 0.165991 5.51572 0.241857 5.59497L4.40844 9.76155C4.48591 9.83966 4.57808 9.90165 4.67962 9.94396C4.78117 9.98627 4.89009 10.008 5.0001 10.008C5.1101 10.008 5.21902 9.98627 5.32057 9.94396C5.42212 9.90165 5.51428 9.83966 5.59175 9.76155Z",
    fill: "#167092"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarrow);
export default __webpack_public_path__ + "static/media/backarrow.1fe9cfb0e5c57590f708c93c83959df3.svg";
export { ForwardRef as ReactComponent };